export const InactiveUserRetentionPeriod: number = 90;